module.exports = __webpack_public_path__ + "static/media/logo-funda@2x.88b41faa.png";